import type { Gender } from '@yadviga/shared'
import { useSession } from '../store/user.store'

/**
 * Picks one of three Russian phrases by user's gender.
 * - female / male / other-or-null (neutral)
 *
 * Use for short UI words that change with grammatical gender:
 * `gendered({ f: 'Готова', m: 'Готов', n: 'Можно' })`
 */
export interface GenderedText {
  f: string
  m: string
  n: string
}

export function pickGendered(gender: Gender | null, text: GenderedText): string {
  if (gender === 'female') return text.f
  if (gender === 'male') return text.m
  return text.n
}

export function useGendered(text: GenderedText): string {
  const gender = useSession((s) => s.user?.gender ?? null)
  return pickGendered(gender, text)
}
